import React, { useContext, useEffect } from 'react';
import { Link } from "react-router-dom";


import { CKEditor } from '@ckeditor/ckeditor5-react';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { RiArrowGoBackLine } from 'react-icons/ri';
import {  Row, Col, Card, Button, Form } from "react-bootstrap";

import useInput from "../../../hooks/useInput";

import { useToasts } from 'react-toast-notifications'
import { warningToast } from "../../../utils/ToastUtil";

import BenefitsContext from "../../../context/Benefits/BenefitsContext";


const editorConfiguration = {
   
    toolbar: [ 'heading', '|', 'bold', 'italic', 'bulletedList','numberedList', '|', 'outdent', 'indent',  '|', 'link', 'blockQuote', 'insertTable', '|', 'undo', 'redo' ],
    table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
    }
};

const FormBenefitAdmin = ({history}) => {

    const { addToast } = useToasts();
    const benefitsContext = useContext(BenefitsContext);
    const {loading, benefit, saveBenefit, uploadBenefit, cleanBenefit} = benefitsContext;

    const { value, setValue, onChange } = useInput({});

    useEffect( () => {
       if(benefit){ setValue(benefit)}
       else{
        setValue({
            expirationDate: null,
            information: null,
            resume: null,
            title: null
        })
       }
       // eslint-disable-next-line
    }, [benefit])

    const save = async() => {
        if(!value.title || value.title.trim() === ''){ addToast('Debe Completar campo "Título"!', warningToast()); return;}
        if(!value.expirationDate || value.expirationDate.trim() === ''){ addToast('Debe Completar campo "Fecha que caduca el beneficio"!', warningToast()); return;}
        if(!value.resume || value.resume.trim() === ''){ addToast('Debe Completar campo "Resumen"!', warningToast()); return;}
        if(!value.information || value.information.trim() === ''){ addToast('Debe Completar campo "Información del Beneficio"!', warningToast()); return;}

        const response = await saveBenefit(value);
        if(response){ history.push(`/admin/benefit`); }
    }

    const update = async() => {
  
        if(!value.title || value.title.trim() === ''){ addToast('Debe Completar campo "Título"!', warningToast()); return;}
        if(!value.expirationDate || value.expirationDate.trim() === ''){ addToast('Debe Completar campo "Fecha que caduca el beneficio"!', warningToast()); return;}
        if(!value.resume || value.resume.trim() === ''){ addToast('Debe Completar campo "Resumen"!', warningToast()); return;}
        if(!value.information || value.information.trim() === ''){ addToast('Debe Completar campo "Información del Beneficio"!', warningToast()); return;}
       
        const response = await uploadBenefit(value.id, value);
        if(response){ cleanBenefit(); history.push(`/admin/benefit`);}
    }

    return ( 
        <>
             <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Administración de Beneficios</h1>
                    <hr />
                </Col>
            </Row>
            <Row >   
                <Col lg={4}>
                    <Link to={"/admin/benefit"}>
                        <Button   className={"col-lg-10"} variant="outline-secondary" onClick={cleanBenefit}>
                            <RiArrowGoBackLine />Atrás
                        </Button>
                    </Link>
                </Col>        
                <Col lg={8} >         
                {benefit.id ? 
                    <Button className={"col-lg-12"} onClick={update} disabled={loading}>Actualizar</Button>
                    :
                    <Button className={"col-lg-12"} onClick={save} disabled={loading}>Agregar</Button>
                }
                </Col>
          </Row>
          <hr />

            <Row>
                <Col>
                    <Card>
                        <Card.Header>Formulario</Card.Header>
                        <Card.Body>
                          
                            <Form>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Título </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Enter email" 
                                        name="title"
                                        value={value.title}
                                        onChange={onChange}
                                        max={40}
                                        maxLength={40}                                      
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Fecha que caduca el beneficio</Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        name="expirationDate"
                                        value={value.expirationDate}
                                        onChange={onChange}
                                     
                                        />
                                </Form.Group>

                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Resumen (90 caracteres máximo)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Este es un resumen del beneficio" 
                                        name="resume"
                                        value={value.resume}
                                        onChange={onChange}  
                                        max={89}
                                        maxLength={89}                                      
                                        />
                                </Form.Group>
                            </Form>
                            
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <br/>

            <Row>
                <Col>
                    <Card>
                        <Card.Header>Información del Beneficio</Card.Header>
                        <Card.Body>
                          
                            <Card.Text>                            
                                <CKEditor
                                    editor={ ClassicEditor }
                                    config={editorConfiguration}
                                    name="information"
                                    data={value.information}                                    
                                    onChange={ ( event, editor ) => {
                                       
                                        const data = editor.getData();
                                 
                                        value.information = data;        
                                    } }
                                />                                    
                            </Card.Text>
                            
                        </Card.Body>
                    </Card>         
                </Col>
            </Row>

        </>
     );
}
 
export default FormBenefitAdmin;